export class RecepcionCamion {
    domicilioTransportista: string;
    cuitTransportista: string;
    nombreTransportista: string;
    nombreConductor: string;
    documentoConductor: string;
    patenteCamion: string;
    patenteAcoplado?: string;
    precintoFijo: string;
    precintoDesdeCamion: string;
    precintoHastaCamion: string;
}